import { IconList, ResponsiveImage } from '@sleepstation/components'
import { BreakingLayout } from '@sleepstation/components-layouts'
import {
  DIRECTION,
  LAYOUT_CHILD,
  LAYOUT_SPACING,
  LAYOUT_ALIGN,
} from '@sleepstation/const'
import { mq, paddingTop } from '@sleepstation/style-api-helpers'
import { reduceObjIndexed } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import { append } from 'ramda'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const factory = (name, config) => {
  if (name === `bullets`) {
    return (
      <IconList
        shouldCenterRow={false}
        iconName={config.icon.name}
        iconType={config.icon.type}
        values={config.values}
        baselines={[1]}
      />
    )
  }

  throw new Error(`[BenefitsCard] primary no recognised variant`)
}

const renderPrimary = reduceObjIndexed((acc, [name, config]) => {
  const component = factory(name, config)
  return append(component, acc)
}, {})

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(BreakingLayout).attrs(() => ({
  spacing: [LAYOUT_SPACING.LARGE, LAYOUT_SPACING.X_LARGE],
  direction: [DIRECTION.VERTICAL, DIRECTION.HORIZONTAL],
  child: [LAYOUT_CHILD.FIGHT, LAYOUT_CHILD.FIGHT],
  align: [LAYOUT_ALIGN.STRETCH, LAYOUT_ALIGN.CENTER],
  'data-cy': `benefits-card`,
}))`
  ${paddingTop(1)}
`

const ImageWrapper = styled.div`
  ${mq(`xSmallOnly`)} {
    margin: 0 auto;
    width: 70%;
  }
`

const Primary = styled.div`
  ${mq(`smallOnly`)} {
    min-width: 230px;
  }

  ${mq(`mediumUp`)} {
    min-width: 260px;
  }
`

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const BenefitsCard = ({ image, primary }) => (
  <Layout>
    <ImageWrapper>
      <ResponsiveImage
        aspectRatio={image.aspectRatio}
        src={image.url}
        alt={image.alt}
      />
    </ImageWrapper>
    <Primary>{renderPrimary(primary)}</Primary>
  </Layout>
)

BenefitsCard.propTypes = {
  image: PropTypes.object.isRequired,
  primary: PropTypes.object.isRequired,
}

BenefitsCard.defaultProps = {}

export default BenefitsCard
